import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { getDDProductsToMapByChargeNameApi } from 'api';
import useStyles from '../styles';
import { headTableCells } from './helpers/changeMapping';
import MapCatalogTableHeadRow from './MapCatalogTableHeadRow';
import MapCatalogTableRow from './MapCatalogTableRow';
import TableFilterRow from './TableFilterRow';


const MapCatalogTable = ({setSelectedItem}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [sort, setSort] = useState({fieldName: 'catalogName', sortDirection: 'asc'});
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});

  const {
    ddCatalogProducts,
    ddCatalogProductsTotal,
    ddCatalogProductsLoading
  } = useSelector((state: IReduxState) => state.dataDictionary);

  useEffect(() => {
    getDDProductsToMapByChargeNameApi({
      dispatch,
      sort,
      filters,
      currentPage,
      rowsPerPage
    });
  }, [
    sort,
    filters,
    currentPage,
    rowsPerPage
  ]);

  const handleRequestSort = (_, property) => {
    const {fieldName, sortDirection} = sort;
    const isDesc = fieldName === property && sortDirection === 'desc';
    setSort(() => ({fieldName: property, sortDirection: isDesc ? 'asc' : 'desc'}));
  };

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <div className="border-1-light-grey border-radius-8 p-4 mt-4 ">
      <TableContainer className={`relative ${classes.table}`}>
        <Table className={classes.table}>
          <TableHead>
            <MapCatalogTableHeadRow
              sort={sort}
              handleRequestSort={handleRequestSort}
            />
          </TableHead>
          <TableBody>
            <TableFilterRow
              headTableCells={headTableCells}
              filters={filters}
              setFilters={setFilters}
            />
            {ddCatalogProducts.length ?
              ddCatalogProducts.map((item) => (
                <MapCatalogTableRow
                  key={item.id}
                  item={item}
                  setSelectedItem={setSelectedItem}
                />
              ))
              :
              <TableRow>
                <TableCell colSpan={12}>
                  <p className="text-center text-muted">No mapping data.</p>
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {!!ddCatalogProductsTotal &&
      <TablePagination
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        component="div"
        className={classes.paginationContainer}
        count={ddCatalogProductsTotal}
        rowsPerPage={rowsPerPage}
        page={currentPage - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      }
      <BackdropCircular loading={ddCatalogProductsLoading} local />
    </div>
  );
};

export default MapCatalogTable;
